import React from 'react';

import { frontendConfig } from '../../../../../core/system/config/frontend.server.js';

const SaveArticleReminder: React.FC<{ handleClose: () => void }> = ({
  handleClose,
}) => {
  return (
    <div className="save-reminder">
      <p className="save-reminder-title">
        <b>Hei!</b> Legg saken i en liste
      </p>
      <button onClick={handleClose}>
        <img
          src={`${frontendConfig.cdnUrlInternal}/vink/images/icons/cross_bold.svg`}
          alt="Lukk påminnelse"
        />
      </button>
    </div>
  );
};

export default SaveArticleReminder;
